import { Grid } from '@mui/material'
import { Modal } from 'components/core-ui/Modal'
import { useMemo } from 'react'
import { getAssocitionName } from './helpers'
import { Button } from '@fullscreendigital/carrefour-dex-fe'

interface ShopReceptionNoAssociationModalProps {
  type: string
  isOpen: boolean
  onClose: () => void
}

const ShopReceptionNoAssociationModal = (props: ShopReceptionNoAssociationModalProps) => {
  const { type, isOpen, onClose } = props

  const associationName = useMemo(() => getAssocitionName(type), [type])

  return (
    <Modal isModalOpen={isOpen} closeModal={onClose}>
      <Grid container spacing={4}>
        <Grid xs={12} item>
          Nu aveti un {associationName} asociat contului. Va rugam sa contactati responsabilul
          Carrefour pentru asocierea la {associationName}!
        </Grid>

        <Grid xs={6} item />
        <Grid xs={6} item style={{ textAlign: 'right' }}>
          <Button variant="contained" label="Ok" onClick={onClose} />
        </Grid>
      </Grid>
    </Modal>
  )
}

export default ShopReceptionNoAssociationModal
